module.exports = __webpack_public_path__ + "static/media/11.d5f40e86.jpg";